import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '购物返利', path: '/category/gouwu-fanli' },
    { name: '免费试用', path: '/category/mianfei-shiyong' },
    { name: '会员权益', path: '/category/huiyuan-quanyi' },
  ],
  更多资源: [
    { name: '折扣优惠', path: '/category/zhekou-youhui' },
    { name: '生活福利', path: '/category/shenghuo-fuli' },
    { name: '金融福利', path: '/category/jinrong-fuli' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '用户口碑', path: '/about' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gift-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-foreground-950 font-bold">
                福利导航在线
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一站式福利资源聚合平台，为您精选全网优质福利资源，涵盖生活优惠、会员权益、折扣活动等多类福利内容，实时更新，免费使用。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 福利导航在线 - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer transition-colors" rel="nofollow">
              使用条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer transition-colors" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}